'use client'

import Avatar from '@component/avatar'
import DisablePrefetchLink from '@component/disablePrefetchLink'
import Tooltip from '@component/tooltip'
import IconCopy from '@icon/house/copy.svg'
import { enquiryDataLayer } from '@plugin/google/gtm/modules/property'
import { statsHouseDetailPhoneClick } from '@plugin/statistics'
import { agentDetail, houseDetail } from '@router'
import { global } from '@store/index'
import { blockNumber } from '@utils'
import { getHouseId, isVillageTypeUnitData } from '@utils/house'
import ClipboardJS from 'clipboard'
import { get } from 'lodash-es'
import { useEffect, useRef } from 'react'
import { useBoolean } from 'react-use'
import { useRecoilValue } from 'recoil'
import AgentEmailButton from '../button/email'

export default function AgentGallery({
  data,
  house
}) {

  const { isMobile } = useRecoilValue(global)
  const [showPhone, togglePhone] = useBoolean(false)
  const [copySuccess, toggleCopySuccess] = useBoolean(false)
  const copyRef = useRef(null)
  const timer = useRef(null)

  useEffect(() => {
    if (!copyRef.current || !showPhone) return

    const clipboard = new ClipboardJS(copyRef.current, {
      text: () => data.phoneNumber
    })
    clipboard.on('success', () => {
      toggleCopySuccess(true)
      clearTimeout(timer.current)
      timer.current = setTimeout(() => {
        toggleCopySuccess(false)
      }, 3000)
    })

    return () => {
      clipboard.destroy()
    }
  }, [data, copyRef, timer, showPhone, toggleCopySuccess])

  function copyHandle(event) {
    event.preventDefault()
    event.stopPropagation()
    enquiryDataLayer.phoneCopy()
  }
  function handleDisplayPhone() {
    togglePhone(true)
    enquiryDataLayer.phoneClick()
    statsHouseDetailPhoneClick(get(data, 'id'), getHouseId(house))
  }
  return (
    <div className='shadow-card-sm p-20 rounded-sm'>
      <div className='flex items-center'>
        <DisablePrefetchLink href={agentDetail(data)}>
          <Avatar src={data.icon} circle alt={data.name} width={64} height={64} defaultIcon='icon-avatar' iconSize='!text-xl'></Avatar>
        </DisablePrefetchLink>
        <div className='ml-16 flex-1'>
          <DisablePrefetchLink href={agentDetail(data)} className='block'>
            <div className='text-font text-lg'>{data.name}</div>
            <div className='text-neutral-5 text-base'>{data.jobTitle}</div>
          </DisablePrefetchLink>
          <Tooltip
            zIndex={201}
            active={copySuccess}
            disabled
            bottom={isMobile}
            right={!isMobile}
            content={<div className='text-secondary text-md px-10 py-2'>Copied!</div>}
            className='max-w-full'
          >
            <a
              href={`tel:${data.phoneNumber}`}
              className='button-primary-out h-32 mt-8 w-full px-8'
              onClick={handleDisplayPhone}
              data-noprogress
            >
              {
                !showPhone && (
                  <i className='icon icon-phone text-primary mr-8'></i>
                )
              }
              <span className='text-ellipsis whitespace-nowrap overflow-hidden'>{showPhone ? data.phoneNumber : blockNumber(data.phoneNumber)}</span>
              {
                showPhone && (
                  <>
                    <i className='w-1 h-14 bg-primary ml-8'></i>
                    <button className='cursor-pointer h-full px-8 -mr-8' onClick={copyHandle} ref={copyRef}>
                      <IconCopy width={14} height={14} fill='var(--color-theme)' className='block'></IconCopy>
                    </button>
                  </>
                )
              }
            </a>
          </Tooltip>
        </div>
      </div>
      <AgentEmailButton data={data} house={house} sendAllAgent className='mt-16'>Enquire</AgentEmailButton>
    </div>
  )
}

export function VillagerGallery({
  house
}) {
  const { villageParentSlug, slug, villageLogoDetail, villageContactName = '' } = house
  const isVillageUnit = isVillageTypeUnitData(house)

  if (!(isVillageUnit ? villageParentSlug : slug) || !villageLogoDetail || !villageContactName) {
    return null
  }

  return (
    <div className='shadow-card-sm p-20 rounded-sm'>
      <DisablePrefetchLink href={houseDetail({ slug: isVillageUnit ? villageParentSlug : slug })} className='flex items-center'>
        <Avatar src={villageLogoDetail} circle alt={villageContactName} width={64} height={64} defaultIcon='icon-avatar' iconSize='!text-xl'></Avatar>
        <div className='ml-16'>
          <div className='text-font text-lg'>{villageContactName}</div>
        </div>
      </DisablePrefetchLink>
      <AgentEmailButton house={house} sendAllAgent className='mt-16'>Enquire</AgentEmailButton>
    </div>
  )
}